module.exports = __webpack_public_path__ + "img/builder-34.9a4d657e.jpg";